export const NumberOfPresamplesBeforeTimeZero = 300;
export const UnixEpoch = new Date(0);
